import { Button, Typography } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import InputBase from '@material-ui/core/InputBase';
import {
	createStyles,
	fade, makeStyles
} from "@material-ui/core/styles";
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SearchIcon from '@material-ui/icons/Search';
import React from "react";
import { Rnd } from 'react-rnd';
import { useActions, useValues } from 'kea';
import Fuse from 'fuse.js';

import vehiclelogic from 'src/store/vehicle';
import { maplogic, preferenceslogic } from 'src/store/global';


import Results from "./Results";

//TODO clean styles
const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			width: "100%",
			// height: "100%",
			minHeight: 0,
			flexGrow: 1,
		},
		container: {
			maxHeight: 440,
		},
		search: {
			position: 'relative',
			borderRadius: theme.shape.borderRadius,
			backgroundColor: fade(theme.palette.common.white, 0.15),
			'&:hover': {
				backgroundColor: fade(theme.palette.common.white, 0.25),
			},
			marginRight: theme.spacing(2),
			marginLeft: 0,
			width: '100%',
			[theme.breakpoints.up('sm')]: {
				marginLeft: theme.spacing(3),
				width: 'auto',
			},
		},
		searchIcon: {
			padding: theme.spacing(0, 2),
			height: '100%',
			position: 'absolute',
			pointerEvents: 'none',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		inputRoot: {
			color: 'inherit',
		},
		inputInput: {
			padding: theme.spacing(1, 1, 1, 0),
			// vertical padding + font size from searchIcon
			paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
			transition: theme.transitions.create('width'),
			width: '100%',
			[theme.breakpoints.up('md')]: {
				width: '20ch',
			},
		},
	}));


const useStyles2 = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
		display: 'none',
		[theme.breakpoints.up('sm')]: {
			display: 'block',
		},
	},
	search: {
		position: 'relative',
		borderRadius: theme.shape.borderRadius,
		backgroundColor: fade(theme.palette.common.white, 0.15),
		'&:hover': {
			backgroundColor: fade(theme.palette.common.white, 0.25),
		},
		marginLeft: 0,
		width: '100%',
		[theme.breakpoints.up('sm')]: {
			marginLeft: theme.spacing(1),
			width: 'auto',
		},
	},
	searchIcon: {
		padding: theme.spacing(0, 2),
		height: '100%',
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	inputRoot: {
		color: 'inherit',
	},
	inputInput: {
		padding: theme.spacing(1, 1, 1, 0),
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
		transition: theme.transitions.create('width'),
		width: '100%',
		[theme.breakpoints.up('sm')]: {
			width: '15ch',
			'&:focus': {
				width: '20ch',
			},
		},
	},
	expand: {
		color: "white",
	},
	expandOpen: {
		color: "white",
	}
}));

const columns = [
	{
		field: 'name',
		headerName: 'name',
		width: 250,
		align: 'left',
	},
	{
		field: 'actions',
		headerName: 'Actions',
		align: 'left',
		sortable: false,
		width: 100,
	}
];


const MobileVehicleTablePanel = () => {
	const classes = useStyles();
	const classes2 = useStyles2();
	const [showAllStatus, setShowAllStatus] = React.useState(false);

	const { vehicles } = useValues(vehiclelogic);
	const { fetchAll } = useActions(vehiclelogic);

	const { vehicle, drawer } = useValues(preferenceslogic);
	const { setVehicle } = useActions(preferenceslogic);

	const { vehicles: vehiclesOnMap } = useValues(maplogic);
	const { addOne, removeOne } = useActions(maplogic);

	const [filtered, setFiltered] = React.useState(vehicles);
	const [search, setSearch] = React.useState('');

	React.useEffect(() => {
		if (search === '') {
			setFiltered(vehicles);
		} else {
			let found = fuse.search(search);
			found = found.map(item => {
				item.item.refIndex = item.refIndex;
				return item.item;
			});
			setFiltered(found);
		}
	}, [vehicles, search])


	React.useEffect(() => {
		vehicles ?? fetchAll();
	}, [])

	if (!vehicles) {
		return <></>
	}
	const fuse = new Fuse(vehicles, {
		keys: ['name', 'registration_number', 'tracker.serial']
	});

	const handle_search = (e) => setSearch(e.target.value);

	const handleExpandClick = () => {
		setVehicle({ ...vehicle, expand: !vehicle.expand });
	};

	const handleOnDrag = (e) => {
		setVehicle({
			...vehicle, position: {
				x: e.layerX - e.offsetX - (drawer.expand ? 220 : 72),
				y: e.layerY - e.offsetY
			}
		})
	}

	const includes_vehiclesOnMap = (mobile_vehicle) => {
		let flag = vehiclesOnMap.find((item) => {
			return item._id === mobile_vehicle._id;
		});
		if (flag === undefined) {
			return false;
		}
		return true;
	}

	const handleShowAllButton = () => {
		let newShowAllStatus = !showAllStatus;
		setShowAllStatus(newShowAllStatus)
		if (newShowAllStatus) {
			vehicles.forEach((item) => {
				// console.log(item);
				if (item.tracker && item.tracker.status.length > 0) {
					if (!includes_vehiclesOnMap(item)) {
						addOne(item);
					}
				}
			})
		} else {
			vehicles.forEach((item) => {
				// console.log(item);
				if (item.tracker && item.tracker.status.length > 0) {
					if (includes_vehiclesOnMap(item)) {
						removeOne(item);
					}
				}
			})
		}
	}

	return (
		<Rnd
			default={{
				x: 0,
				y: 0,
				width: '100%',
			}}
			enableResizing={false}
			bounds={"window"}
			onDragStop={handleOnDrag}
			disableDragging={true}
			cancel={
				"#rnd-ignore-drag"
			}
		>
			<div className={classes.root}>
				<div className={classes2.root}>
					<AppBar position="static">
						<Toolbar variant="dense">

							<div id={'rnd-ignore-drag'} className={classes.search}>
								<div className={classes.searchIcon}>
									<SearchIcon />
								</div>
								<InputBase
									placeholder="Vehicle Search…"
									classes={{
										root: classes.inputRoot,
										input: classes.inputInput,
									}}
									onChange={handle_search}
									inputProps={{ 'aria-label': 'search' }}
								/>
							</div>
							{/* <div>
								<Button variant="contained" color="primary" onClick={handleShowAllButton}>
									{showAllStatus ? 'Hide All' : 'Show All'}
								</Button>
							</div> */}
							<div id={'rnd-ignore-drag'}>
								{vehicle.expand ?
									<Tooltip title='Panel Collapse'>
										<IconButton onClick={handleExpandClick} aria-label="less" className={classes.margin} >
											<ExpandLessIcon htmlColor='white' />
											<Typography style={{ color: 'white' }}>Hide</Typography>
										</IconButton>
									</Tooltip>
									:
									<Tooltip title='Panel Expand'>
										<IconButton onClick={handleExpandClick} aria-label="more" className={classes.margin} >
											<ExpandMoreIcon htmlColor='white' />
											<Typography style={{ color: 'white' }}>Open</Typography>
										</IconButton>
									</Tooltip>
								}
							</div>
						</Toolbar>
					</AppBar>
				</div>

				<Collapse in={vehicle.expand} timeout="auto" unmountOnExit>
					<Results
						rows={filtered}
						columns={columns}
					/>
				</Collapse>
			</div>
		</Rnd>
	);
};

export default MobileVehicleTablePanel;
